import React, { useEffect } from "react";
import { Attributes } from "../pages/SwatchesPage/Filters/Attributes";
import FormControl from "@mui/material/FormControl";
import { Button, TextField } from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { getToken } from "../utils/token";
import Permissions from "../utils/Permissions";

export default function EditSwatch({
  filterAutofIllData,
  swatchDetails,
  setIsLoading,
  refetch,
}) {
  const isDraft = swatchDetails?.state === "Draft";
  // Some swatches are already Available but have never been approved.
  const firstApprovedOn = swatchDetails?.cdata?.first_approved_on;
  const isAwaitingApproval =
    firstApprovedOn === null ||
    firstApprovedOn === undefined ||
    firstApprovedOn === "" ||
    Number(firstApprovedOn) === 0;
  const canApproveSwatch =
    isDraft || (swatchDetails?.state === "Available" && isAwaitingApproval);
  const TOKEN = getToken()
  const permissions = new Permissions();


  const getAttributeValue = (attribute) => {
    if (!attribute) {
      return [];
    } else {
      return attribute.split(",");
    }
  };

  function getEditStateFromSwatch(swatchDetails){
    const initialState = {
      Color: getAttributeValue(swatchDetails?.color),
      Fabric: getAttributeValue(swatchDetails?.basic_fabric),
      Hand: getAttributeValue(swatchDetails?.hand),
      Material: getAttributeValue(swatchDetails?.material),
      Artwork: getAttributeValue(swatchDetails?.artwork),
      Artist: getAttributeValue(swatchDetails?.artist),
      Effect: getAttributeValue(swatchDetails?.effect),
      Techniques: getAttributeValue(swatchDetails?.techniques),
      Era: getAttributeValue(swatchDetails?.era),
      Tag: getAttributeValue(swatchDetails?.cdata?.tag),
      manhours: swatchDetails?.cdata?.manhours || "",
      yearOfCreation: swatchDetails?.year_of_creation || "",
      boxNumber: swatchDetails?.cdata?.box_number || "",
      boxClassification: swatchDetails?.cdata?.box_classification || "",
    };
    return initialState;
  }
  const initialState = getEditStateFromSwatch(swatchDetails)

  const [EditState, setEditState] = React.useState(initialState);

  // console.log("EditState", EditState)

  useEffect(() => {
    setEditState(getEditStateFromSwatch(swatchDetails));
    // eslint-disable-next-line
  }, [swatchDetails?.id]);

  function getSwatchattributeServerValue(attribute) {
    if (attribute && attribute.length > 0) {
      return attribute.join(",");
    } else {
      return undefined;
    }
  }

  function validateForm(editState) {
    // Required fields based on specifications
    const requiredFields = ["yearOfCreation", "boxNumber", "boxClassification"];

    for (let field of requiredFields) {
      if (!editState[field]) {
        toast.error("Please fill all required fields.");
        return false;
      }
    }

    // Artist is required
    if (!editState["Artist"] || editState["Artist"].length === 0) {
        toast.error("Please select at least one Designer (Artist).");
        return false;
    }

    // const currentYear = new Date().getFullYear();
    // if (
    //     +editState["yearOfCreation"] < 1800 ||
    //     +editState["yearOfCreation"] > currentYear
    //   ) {
    //     toast.error("Please enter a valid year of creation(between 1800 and " + currentYear + ")");
    //     return false;
    //   }

    return true;
  }

  async function handleSubmit(changedSwatchDetails) {
    const payload = {
      card_unique_code: swatchDetails?.unique_code,
      color: getSwatchattributeServerValue(changedSwatchDetails?.Color),
      material: getSwatchattributeServerValue(changedSwatchDetails?.Material),
      basic_fabric: getSwatchattributeServerValue(changedSwatchDetails?.Fabric),
      artwork: getSwatchattributeServerValue(changedSwatchDetails?.Artwork),
      artist: getSwatchattributeServerValue(changedSwatchDetails?.Artist),
      effect: getSwatchattributeServerValue(changedSwatchDetails?.Effect),
      techniques: getSwatchattributeServerValue(
        changedSwatchDetails?.Techniques
      ),
      hand: getSwatchattributeServerValue(changedSwatchDetails?.Hand),
      era: getSwatchattributeServerValue(changedSwatchDetails?.Era),
      tag: getSwatchattributeServerValue(changedSwatchDetails?.Tag),
      year_of_creation: changedSwatchDetails?.yearOfCreation
        ? String(changedSwatchDetails?.yearOfCreation)
        : undefined,
      box_number: changedSwatchDetails?.boxNumber
        ? String(changedSwatchDetails?.boxNumber)
        : undefined,
      manhours: changedSwatchDetails?.manhours
        ? String(changedSwatchDetails?.manhours)
        : undefined,
      box_classification: changedSwatchDetails?.boxClassification,
    };

    let response = await axios.patch(
      `https://amal.platform.simplifii.com/api/v1/cards?action=Edit`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + TOKEN,
        },
      }
    );
    if (response.status === 200) {
      await refetch();
    }
    return response;
  }

  async function hanbdleApprove(card_unique_code) {
    const payload = {
      card_unique_code: card_unique_code,
    };

    let response = await axios.patch(
      `https://amal.platform.simplifii.com/api/v1/cards?action=Approve`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + TOKEN,
        },
      }
    );
    if (response.status === 200) {
      await refetch();
    }
    return response;
  }

  const updateState = (updatedFilterState) => {
    // updatedFilterState will be a object of type {filter_key: filter_value}, for EX: {shared_with_client: "true"}
    setEditState((prev) => {
      return { ...prev, ...updatedFilterState };
    });
  };
  return (
    <div className="edit-container">
      <Attributes
        autoFill={filterAutofIllData}
        filters={EditState}
        updateState={updateState}
      />
      <div className="attirubutes-filter-container">
        <div className="input-container">
          <FormControl size="small" fullWidth={true}>
            <TextField
              value={EditState.boxNumber}
              onChange={(e) => updateState({ boxNumber: e.target.value })}
              size="small"
              fullWidth
              label="Box number"
              id="fullWidth"
              required
            />
          </FormControl>
        </div>
        <div className="input-container">
          <FormControl size="small" fullWidth={true}>
            <TextField
              value={EditState.boxClassification}
              onChange={(e) => updateState({ boxClassification: e.target.value })}
              size="small"
              fullWidth
              label="Box Classification"
              id="fullWidth"
              required
            />
          </FormControl>
        </div>
        <div className="input-container">
          <NumberInput
            filters={EditState}
            updateState={updateState}
            itemKey="yearOfCreation"
            label="Year of creation"
          />
        </div>
        <div className="input-container">
          <NumberInput
            filters={EditState}
            updateState={updateState}
            itemKey="manhours"
            label="Manhours spent in creation"
            required={false}
          />
        </div>
      </div>
      <div className="submit-buttom-container">
    
     {canApproveSwatch && permissions.canApprove() &&  <Button
          variant="contained"
          color="success"
          style={{  marginRight: "16px" }}
          onClick={() => toast.promise(hanbdleApprove(swatchDetails?.unique_code), {
            loading: "Approving...",
            success: <b>Swatch Approved Successfully!</b>,
            error:(e) =>  {
            console.log("error", e)
            return <b>{e.message}</b>},
          })
          }
        >
          Approve
        </Button>}
       {permissions.canEdit() &&  <Button
          variant="contained"
          onClick={() =>{

              if (validateForm(EditState)) {
                  toast.promise(handleSubmit(EditState), {
                    loading: "Updating...",
                    success: <b>Swatch Updated Successfully saved!</b>,
                    error: <b>Could not Update Swatch.</b>,
                  })
                } 
          }
          }
        >
          Update
        </Button>}
      </div>
    </div>
  );
}

function NumberInput({ itemKey, filters, updateState, label, required = true}) {
  return (
    <FormControl size="small" fullWidth={true}>
      <TextField
        inputProps={{ type: "number", onWheel: (e) => e.target.blur() }}
        value={filters[itemKey]}
        onChange={(e) => updateState({ [itemKey]: e.target.value })}
        size="small"
        fullWidth
        label={label}
        id="fullWidth"
        required={required}
      />
    </FormControl>
  );
}
